import { enumLabel } from "helpers/system";
import compact from "lodash/compact";
import React from "react";
import configByName from "./configs/configByName";
import Template, { statuses } from "./template";

class Trailer extends Template {
    infoText = () => {
        const { trailerTypeLabel, brand, loadUnloadLabel } = this.state.trailerData || {};
        if (!!trailerTypeLabel || !!brand || loadUnloadLabel) {
            return (
                <div className="offset-sm-4 offset-md-3 col-sm-6 col-md-5">
                    <small className="form-text text-muted">
                        {compact([brand, trailerTypeLabel, loadUnloadLabel]).join(", ")}
                    </small>
                </div>
            );
        }
        return null;
    };

    renderOptionItem = (option) => {
        const { trailerData } = this.state;
        return (
            <li key={option.inputProps.name}>
                {option.label}: {trailerData[option.inputProps.name]}
            </li>
        );
    };

    trailerOptionsText = () => {
        const { trailerOptions } = this.state.trailerData || {};
        if (!trailerOptions) {
            return;
        }
        const options = trailerOptions.value;
        if (options && options.length) {
            return (
                <div className="offset-sm-4 offset-md-3 col-sm-8 col-md-5">
                    <ul className="text-muted pl-0">{options.map(this.renderOptionItem)}</ul>
                </div>
            );
        }
        return null;
    };

    getItem = ({ value }) => {
        const { tripCouplingEnabled, updateTrailerAvailability } = this.props;
        if (!tripCouplingEnabled) {
            updateTrailerAvailability(value);
        }
        if (!value) {
            return this.setState({ trailerData: null });
        }
        const { enums } = this.props;
        this.props
            .getItem({ id: value })
            .then((res) => {
                if (res) {
                    const { brandTypeId, typeId, loadUnloadOptions, ...data } = res;
                    const trailerTypeObj = enums.trailerType.find((item) => item.value === typeId);
                    const trailerOptions = (trailerTypeObj ? trailerTypeObj.options : []).find(
                        (option) => option.id === trailerTypeObj.value,
                    );
                    const valueData = {
                        ...data,
                        trailerTypeLabel: enumLabel(enums.trailerType, typeId),
                        brand: enumLabel(enums.trailerBrandType, brandTypeId),
                        loadUnloadLabel: loadUnloadOptions
                            .map(({ id }) => enumLabel(enums.loadUnloadType, id))
                            .join(", "),
                        trailerOptions,
                    };
                    return this.setState({ trailerData: valueData });
                }
            })
            .catch(() => this.setState({ status: statuses.notFound }));
    };

    render() {
        const { config, value, trailerStatus } = this.props;
        const extendValue = { trailerStatus };
        return (
            <div className="form-group">
                {this.renderSelect({
                    ...config.trailerId,
                    value,
                    extendValue,
                    fieldWrapper: "col-sm-8 col-md-5",
                    bWrapper: "row",
                    onNotFoundHandler: () => {
                        this.setState({ trailerData: null });
                        this.setValue({ name: config.trailerId.inputProps.name, value: null });
                    },
                })}
                <div className="row">
                    {this.infoText()}
                    {this.trailerOptionsText()}
                </div>
            </div>
        );
    }
}

const Configured = (props) => {
    const { baseConfig, tripCouplingEnabled, isEmptyMileageBid } = props;
    const { config, initialState } = configByName.trailer(tripCouplingEnabled, props.firstPoint, props.action);
    if (!isEmptyMileageBid && baseConfig.required) {
        config.trailerId.required = true;
        config.trailerId.validators = baseConfig.validators;
    }
    return <Trailer {...props} config={config} initialState={initialState} />;
};

export default Configured;
